export const CONSENT_COOKIE_KEY = "OptanonConsent";

export const DATA_DOMAIN_SCRIPT_ID = "93fe9d3e-54f3-432b-ae59-ff4e10d79390";
export const AUTO_BLOCK_SCRIPT_URL = `https://cdn.cookielaw.org/consent/${DATA_DOMAIN_SCRIPT_ID}/OtAutoBlock.js`;
export const SDK_SCRIPT_URL =
  "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
